import { useEffect, useRef } from "react";
import styled from "styled-components";

export const ModalAgregarMovimiento = ({
  showNewMovement,
  setShowNewMovement,
  createNewMovement,
}) => {
  //Click outside
  const ref = useRef(null);

  const handleClickOutside = (event) => {
    if (ref.current && !ref.current.contains(event.target)) {
      setShowNewMovement(false);
    }
  };
  useEffect(() => {
    document.addEventListener("click", handleClickOutside, true);
    return () => {
      document.removeEventListener("click", handleClickOutside, true);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  
  const movs = [
    "Alta reserva",
    "Incremento reserva",
    "Disminución reserva",
    "Deducible",
    "Coaseguro",
    "Anticipo",
    "Indemnización",
    "Salvamento",
    "Recuperaciones",
    "Pago ajustadores",
    "Pago expertos"
  ]

  function handleClick(index) {
    setShowNewMovement(false);
    createNewMovement(movs[index]);
  }
  return (
    <Container show={showNewMovement} ref={ref}>
      {movs.map((mov, index) => (
        <Option onClick={() => { handleClick(index) }} key={index}>{mov}</Option>
      ))}
    </Container>
  );
};

const Container = styled.div`
  position: absolute;
  top: 30px;
  right: 0px;
  background-color: white;
  color: var(--neutrals-charcoal);
  z-index: 2;
  min-width: 300px;
  border-radius: 8px;
  padding: 12px 0px;
  font-size: 14px;
  border: 2px solid #eceef3;
  display: ${({ show }) => (show ? "block" : "none")};
`;

const Option = styled.div`
  cursor: pointer;
  transition: 250ms;
  padding: 8px 24px;
  &:hover {
    background-color: #e2e5ee;
  }
`;
